export default {"src":"/_next/static/media/avatar-simple.3263a9f9.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};